export function isWindows(): boolean {
  return navigator.userAgent.indexOf("Win") > -1;
}
